import { createSlice } from '@reduxjs/toolkit';

const provider = createSlice({
  name: 'provider',
  initialState: {
    name: null,
    slug: null,
    uuid: null,
    description: null,
    inviteCode: null,
    isActive: null,
    links: null,
    locations: null,
    userList: null,
    providerLoading: false,
  },
  reducers: {
    loadProviderRequest(state) {
      state.providerLoading = true;
    },
    loadProviderSuccess(state, { payload }) {
      return {
        ...payload.data,
        providerLoading: false,
      };
    },
    loadProviderFailure(state) {
      state.providerLoading = false;
    },
    createProviderRequest(state) {
      state.providerLoading = true;
    },
    createProviderSuccess(state, { payload }) {
      state.providerLoading = false;
    },
    createProviderFailure(state) {
      state.providerLoading = false;
    },
    addServiceRequest(state) {
      state.providerLoading = true;
    },
    addServiceSuccess(state, { payload }) {
      state.providerLoading = false;
    },
    addServiceFailure(state) {
      state.providerLoading = false;
    },
  },
});

const { actions, reducer } = provider;

export const {
  addServiceRequest,
  addServiceSuccess,
  addServiceFailure,
  createProviderRequest,
  createProviderSuccess,
  createProviderFailure,
  loadProviderRequest,
  loadProviderSuccess,
  loadProviderFailure,
} = actions;

export default reducer;
